require('./bootstrap');
require('./order');

$(function () {
    $('.datetimepicker-input').datetimepicker();

    //Date picker
    $('.datepicker-input').datetimepicker({
        format: 'L'
    });
    $('.datepicker-input').attr('data-target', '.datepicker-input')
    $('.datepicker-input').attr('data-toggle', 'datetimepicker')

    $('.datepicker').datetimepicker({
        format: 'L'
    });

    $('.datetimepicker').datetimepicker();

    $('#arriving_time').attr('readonly', false);

    //Click outside to close
    $('[data-toggle=datetimepicker]').blur(function() {
        $(this).datetimepicker('hide');
    });

    $('.card').on('expanded.lte.cardwidget', function () {
      	$(this).find('.fa-chevron-down:first').addClass('fa-chevron-up').removeClass('fa-chevron-down');
    });
    $('.card').on('collapsed.lte.cardwidget', function () {
      	$(this).find('.fa-chevron-up:first').addClass('fa-chevron-down').removeClass('fa-chevron-up');
    });

    // prevent multiple submit form
    $('form:not(.ajax-form)').find('[type="submit"]').on('click', function (event) {
        event.preventDefault();
        $(this).prop('disabled', true);
        var form = $(this).closest('form');
        var name = $(this).prop('name');
        if (name != '' || name != undefined) {
            $('<input>').attr({
              'type': 'hidden',
              'name': name,
            }).appendTo(form);
        }
        form.submit();
    });

    $('.alert-dismissable:not([data-dismiss])').attr('data-dismiss', 'alert');
});

$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    locale: 'ja',
    format: 'YYYY/MM/DD HH:mm:ss',
    dayViewHeaderFormat: 'YYYY年 M月',
});

$.extend(true, $.fn.dataTable.defaults, {
    dom: '<"d-lg-flex align-items-lg-baseline datatable-pagi" <"col-lg-3 pl-0 d-sm-flex"i><"col-lg-9 pr-0 d-lg-flex justify-content-lg-end align-items-lg-baseline pl-0" <"mr-3 d-lg-block d-none"l> <"d-lg-block d-none"p> <"d-flex d-lg-none d-block mt-2"p> <"d-flex d-lg-none d-block"l>> >rt<"bottom"f><"clear">',
    language: {
        "sEmptyTable":     "テーブルにデータがありません",
        "sInfo":           " _TOTAL_ 件中 _START_ から _END_ まで表示",
        "sInfoEmpty":      " 0 件中 0 から 0 まで表示",
        "sInfoFiltered":   "（全 _MAX_ 件より抽出）",
        "sInfoPostFix":    "",
        "sInfoThousands":  ",",
        "sLengthMenu":     "_MENU_ 件/ページ",
        "sLoadingRecords": "読み込み中...",
        "sProcessing":     "<i class='fa fa-spinner fa-spin fa-3x fa-fw'></i>",
        "sSearch":         "検索:",
        "sZeroRecords":    "一致するレコードがありません",
        "oPaginate": {
            "sFirst":    "先頭",
            "sLast":     "最終",
            "sNext":     '<i class="fa fa-angle-double-right"></i>',
            "sPrevious": '<i class="fa fa-angle-double-left"></i>'
        },
        "oAria": {
            "sSortAscending":  ": 列を昇順に並べ替えるにはアクティブにする",
            "sSortDescending": ": 列を降順に並べ替えるにはアクティブにする"
        }
    },
    fnPreDrawCallback : function() {
        $(this).parent().parent().find('.alert').remove();
        $(".dataTables_processing").removeClass("card");
    },
    fnDrawCallback : function() {
        if ($(this).find('.dataTables_empty').length == 1) {
            $(this).parent().hide();
            $(this).parent().parent().append('<div role="alert" class="alert alert-warning">条件に一致するデータはありません。</div>');
        } else {
            $(this).parent().show();
        }
    }
});
$.fn.dataTable.ext.errMode = 'none';
$.fn.dataTable.ext.pager.numbers_length = 5;

moment.locale('ja');
$('.daterange-picker').daterangepicker({
    "autoApply": true,
    ranges: {
        '前日': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去7日間': [moment().subtract(6, 'days'), moment()],
        '過去30日間': [moment().subtract(29, 'days'), moment()],
        '当月': [moment().startOf('month'), moment().endOf('month')],
        '前月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    },
    "locale": {
        "format": "YYYY年MM月DD日",
        "separator": " 〜 ",
    },
    "showCustomRangeLabel": false,
    "showDropdowns": true,
    "alwaysShowCalendars": true
}).on('showCalendar.daterangepicker', function() {
    $('.daterangepicker .yearselect option').each(function(){
        $(this).text($(this).val() + ' 年');
    });
});

$('.datepicker').daterangepicker({
    "autoApply": true,
    "singleDatePicker": true,
    "showDropdowns": true,
    "autoUpdateInput": false,
    "locale": {
        "format": "YYYY/MM/DD"
    },
    "alwaysShowCalendars": true
}).on("apply.daterangepicker", function (e, picker) {
    picker.element.val(picker.startDate.format(picker.locale.format));
});

$('.datepicker').on('showCalendar.daterangepicker', function() {
    $('.daterangepicker .yearselect option').each(function() {
        $(this).text($(this).val() + ' 年');
    });
});

$('.datetimepicker').daterangepicker({
    "autoApply": true,
    "timePicker": true,
    "singleDatePicker": true,
    "timePicker24Hour": true,
    "timePickerSeconds": true,
    "showDropdowns": true,
    "locale": {
        "format": "YYYY/MM/DD HH:mm:ss",
        "separator": " 〜 ",
        "applyLabel": "選択",
        "cancelLabel": "キャンセル",
        "firstDay": 1
    },
    "alwaysShowCalendars": true,
    "autoUpdateInput": false,
});

$('.datetimepicker').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format(picker.locale.format));
});

$('.datetimepicker').on('cancel.daterangepicker', function (ev, picker) {
    $(this).val('');
});

$('.datetimepicker').on('showCalendar.daterangepicker', function() {
    $('.daterangepicker .yearselect option').each(function(){
        $(this).text($(this).val() + ' 年');
    });
});

$('.monthly-picker').daterangepicker({
    "singleDatePicker": true,
    "locale": {
        "format": "YYYY年MM月度"
    }
});

$(window).scroll(function() {
    if ($(window).scrollTop() > 20) {
        $('#goToTopBtn').css('display', 'block');
    } else {
        $('#goToTopBtn').css('display', 'none');
    }
});

$(document).on('click','#goToTopBtn', function(e){
    $(window).scrollTop(0);
});

$('.card-tools').parent('.card-header').attr('data-card-widget', 'collapse');

$('.timepicker-input').attr('readonly', 'true').css('background-color', '#fff');